import React, { useMemo } from 'react';
import { WEBINAR_STATES, WEBINAR_TYPES } from 'utils/Constants';

import Show from 'components/Show';
import Pill from 'components/Misc/Pill';
import Container from 'components/Misc/Container';
import { Title } from 'components/Misc/Typography';
import { Button, Datepicker } from 'components/Misc/Form';

import { useAppStore } from 'store/useAppStore';
import { useWebinarProfileStore } from 'store/webinar/useWebinarProfileStore';

const Information = () => {
	// User app's store
	const role = useAppStore(state => state.user.role);

	// Use webinar's profile store
	const [webinar, subject] = useWebinarProfileStore(state => [state.webinar, state.subject]);

	// Find status info
	const status = useMemo(() => WEBINAR_STATES.find(status => status.value === webinar.status), [webinar.status]);
	const type = useMemo(() => WEBINAR_TYPES.find(type => type.value === webinar.type), [webinar.type]);

	return (
		<Container className="p-4 space-y-2">
			<div className="flex space-x-2">
				<Title
					title={webinar.title}
					subtitle={subject.title}
					className="flex-1 text-xl"
				/>

				<Show if={['admin', 'employee'].includes(role)}>
					<Button
						small
						square
						icon="edit"
						to={`/webinars/edit/${webinar.id}`}
						className="font-normal"
					/>
				</Show>
			</div>

			<div className="flex flex-wrap gap-2">
				<Datepicker
					time
					readOnly
					value={webinar.eventAt}
				/>

				<Pill
					name={status?.text}
					theme={status?.theme}
				/>

				<Pill
					name={type?.text}
					theme={type?.theme}
				/>
			</div>
		</Container>
	);
};

export default Information;